import React from 'react';
import { NavLink } from 'react-router-dom';
const Us1_pre_sub = () => {
  return (
    <div className='fixed top-16 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-cyan-400 items-center z-50 justify-evenly'>
      
      <NavLink to="/tutoring/learner/us1/us1_pre/us1_pre_cre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Creative Arts</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_pre/us1_pre_cre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Literacy and Language Arts</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_pre/us1_pre_cre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Math</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_pre/us1_pre_cre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Music and Movement</NavLink>        
        <NavLink to="/tutoring/learner/us1/us1_pre/us1_pre_cre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Physical Development</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_pre/us1_pre_cre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Practical Life/Self-Care</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_pre/us1_pre_cre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Science</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_pre/us1_pre_cre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Social-Emotional Development</NavLink>        
      <NavLink to="/tutoring/learner/us1/us1_pre/us1_pre_soc" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Social Studies</NavLink>     
      
      
    </div>
  );
}

export default Us1_pre_sub;
